import React from 'react';
import classNames from 'classnames';
import style from './App.less';

import { injectIntl } from 'react-intl';
import { inject, toggleInject } from "../components/injector";

import getI18nBundle, { browserLocale } from '../components/get-i18n-bundle';
const language = browserLocale.toLowerCase().split('-')[0];
class Error3 extends React.PureComponent {
    componentDidMount() {
        document.title = this.props.intl.formatMessage({ id: 'faultTitle' })
    }
    strs = (id) => {
        const { formatMessage } = this.props.intl;
        const data = formatMessage({ id: id });
        return data.replace(/(\r\n)|(\n)/g, '<br/>');
    };

    render() {
        const { pwr, intl, history } = this.props;
        return (
            <div className={style.errorPage}>
                <div className={style.errorTitle}>{intl.formatMessage({ id: 'error3Title' })}</div>
                <div className={style.errorContent}>
                    <div className={style.errorDesc}>{intl.formatMessage({ id: 'error1desc' })}
                        {
                            language !== 'fr' && language !== 'es' && <span> {intl.formatMessage({ id: 'error1call' })} <a>{intl.formatMessage({ id: 'errorTle' })}</a></span>
                        }
                    </div>
                    <table>
                        <tbody>
                            <tr>
                                <td>{intl.formatMessage({ id: 'errorReason' })}</td>
                                <td>{intl.formatMessage({ id: 'resolvent' })}</td>
                            </tr>
                            <tr>
                                <td>{intl.formatMessage({ id: 'error3A' })}</td>
                                <td>{intl.formatMessage({ id: 'error3AMethod' })}</td>
                            </tr>
                        </tbody>

                    </table>
                </div>
            </div>

        )
    }
}



export default inject()(injectIntl(Error3));